import { useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";
import { formatPrice, formatMacros } from "@/lib/format";

const StickyCart = ({ cartCount, totals, onView }) => {
  const { t } = useTranslation();
  if (cartCount === 0) return null;
  return (
    <div
      data-testid="sticky-cart"
      className="fixed bottom-0 inset-x-0 z-40 pointer-events-none"
    >
      <div className="mx-auto max-w-md px-4 pb-4 pointer-events-auto">
        <button
          data-testid="sticky-cart-view"
          onClick={onView}
          className="w-full bg-neutral-900 text-white rounded-2xl px-4 py-3.5 flex items-center justify-between shadow-2xl active:scale-[0.99] transition-transform"
        >
          <div className="flex items-center gap-3 text-left min-w-0">
            <div className="w-8 h-8 rounded-full bg-[#E34A27] flex items-center justify-center text-sm font-black shrink-0">
              {cartCount}
            </div>
            <div className="min-w-0">
              <div className="text-[10px] font-mono uppercase tracking-wider text-white/60">{formatMacros(totals)}</div>
              <div className="text-base font-bold truncate">
                {t("cart.viewOrder", { price: formatPrice(totals.price) })}
              </div>
            </div>
          </div>
          <ChevronRight size={20} className="shrink-0" />
        </button>
      </div>
    </div>
  );
};

export default StickyCart;
